import { makeStyles } from 'tss-react/mui';
import { theme } from '../../../../theme';

/**
 * Custom hook that defines the styles for the order button component.
 */
const useOrderButtonStyles = makeStyles()(() => ({
  btn: {
    'fontFamily': theme.fontFamily,
    'borderRadius': '20px',
    'backgroundColor': theme.background.paper,
    'color': theme.text.primary.light,
    '&.Mui-selected': {
      'color': theme.text.primary.dark,
      'backgroundColor': theme.primary.light,
      '&:hover': {
        color: theme.text.primary.dark,
        backgroundColor: theme.primary.dark,
      },
      '&:active': {
        backgroundColor: theme.primary.darker,
        boxShadow: theme.buttonShadow(theme.primary.darker),
        color: theme.text.primary.dark,
      },
    },
    '&: active': {
      backgroundColor: theme.primary.darker,
      boxShadow: theme.buttonShadow(theme.primary.darker),
      color: theme.text.primary.dark,
    },
    'padding': '6px 16px', // Spacing around the button content
    'fontSize': '0.875rem',
  },
}));

export default useOrderButtonStyles;
